enum EngineType {
    OUTBOARD = 'Outboard',
}

export default EngineType
